export class SubTravelInfoResourceConfig {
  startDateLabel = 'sub-travel-info-departure-date';
  startDateLocationLabel = 'sub-travel-info-departure-from';
  endDateLabel = 'sub-travel-info-arrival-date';
  endDateLocationLabel = 'sub-travel-info-arrival-at';
  agencyRefLabel = 'sub-travel-info-agency-reference-number';
}
